import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { formatApiError } from "@/lib/api";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const s = useSettings();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full rounded-lg bg-black/40 border border-white/10 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400/30 focus:outline-none px-3.5 py-2.5 text-sm text-white placeholder:text-zinc-500";

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grid place-items-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#101010] p-8">
        <div className="flex items-center justify-center mb-6">
          <img src={s.logo_url} alt="VINKO" className="h-16 w-auto" />
        </div>
        <h1 className="text-2xl font-bold text-center tracking-tight">Accesso amministratore</h1>
        <p className="text-sm text-zinc-400 text-center mt-1">Area riservata al team Vinko.</p>

        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-zinc-500">Email</label>
            <input required type="email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-zinc-500">Password</label>
            <input required type="password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          </div>
          <button
            type="submit" disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-yellow-400 hover:bg-yellow-300 disabled:opacity-60 text-black font-bold text-sm px-6 py-3 transition-transform duration-200 hover:scale-[1.01]"
          >
            <LogIn className="w-4 h-4" /> {loading ? "Accesso..." : "Entra"}
          </button>
        </form>
      </div>
    </div>
  );
}
